import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import Aos from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import BaseUrl from "../../base-api";
import Loader from "../Loader/Loader";

const Images = () => {
  const [otp, setOtp] = useState("");
  const [bankData, setBankData] = useState(null);
  const [otpSent, setOtpSent] = useState(false);
  const [errors, setErrors] = useState({});
  const [resendTimer, setResendTimer] = useState(0);
  const [state, setState] = useState([])
  const [district, setDistrict] = useState([])
  const [program, setProgram] = useState([])
  const [alc, setAlc] = useState([])
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const data = async () => {
    setLoading(true)
    try {
      const token = sessionStorage.getItem("userToken");
      if (!token) {
        navigate("/login")
        return
      }
      const res = await axios.get(`${BaseUrl}/api/reg/registrationDto`, {
        headers: {
          'Content-Type': "application/json"
        },

      });

      if (res) {

        setState(res.data.state)
        setProgram(res.data.programs)
      }


    } catch (error) {
      console.log(error.response?.data?.message);
    } finally {
      setLoading(false);
    }

  }
  useEffect(() => {
    Aos.init({ duration: 2000 });
    window.scrollTo(0, 0);


    data();
  }, []);

  const selectDistrict = async (e) => {
    setLoading(true)
    try {

      const res = await axios.get(`${BaseUrl}/api/reg/districts`, {
        params: { stateCode: e.target.value },
        headers: {
          'Content-Type': "application/json"
        },

      });

      if (res) {

        setDistrict(res.data)
      }


    } catch (error) {
      console.log(error.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }
  const selectAlc = async (e) => {
    setLoading(true)
    try {

      const res = await axios.get(`${BaseUrl}/api/reg/alcs`, {
        params: { districtCode: e.target.value },
        headers: {
          'Content-Type': "application/json"
        },

      });

      if (res) {


        if (res.data.length == 0) {
          setAlc([{
            "name": "HKCL",
            "code": "295130001"
          }])
        }

        else {
          setAlc(res.data)
        }
      }


    } catch (error) {
      console.log(error.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    fname: "",
    dob: "",
    email: "",
    number: "",
    state: "",
    district: "",
    program: "",
    alc: "",
    declaration: false,
  });



  useEffect(() => {
    let timer;
    if (resendTimer > 0) {
      timer = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    } else {
      clearInterval(timer);
    }
    return () => clearInterval(timer);
  }, [resendTimer]);

  const handleOTPChange = (e) => {
    let newValue = e.target.value;
    newValue = e.target.value.replace(/\D/g, "");
    if (newValue.length > 6) {
      newValue = newValue.slice(0, 6);
    }

    setOtp(newValue);
  };

  const sendOtp = async () => {

    if (validateForm()) {
      setLoading(true)
      try {
        const data = new FormData();
        data.append("mobileNumber", formData.number)
        const res = await axios.post(`${BaseUrl}/api/notification/sendOtp`, data, {
          headers: {
            'Content-Type': "application/json"
          },

        });
        if (res) {
          toast.success(res.data.message);
          setErrors({});
          setOtpSent(true);
          setResendTimer(120);
          setOtp("");
        }
        else {
          toast.error(res.data?.message);
        }

      } catch (error) {
        toast.error(error.response?.data?.message);
      }
      finally {
        setLoading(false);
      }
    }
  };


  const verifyOtp = async () => {
    if (validateForm()) {
      setLoading(true)
      try {
        const data = new FormData();
        data.append("firstName", formData.firstName)
        data.append("lastName", formData.lastName)
        data.append("fatherName", formData.fname)
        data.append("dob", formData.dob)
        data.append("email", formData.email)
        data.append("mobileNumber", formData.number)
        data.append("stateCode", formData.state)
        data.append("districtCode", formData.district)
        data.append("programCode", formData.program)
        data.append("alcCode", formData.alc)
        data.append("otp", otp)
        const res = await axios.post(`${BaseUrl}/api/reg/registration`, data, {
          headers: {
            'Content-Type': "application/json"
          },

        });
        if (res) {
          toast.success(res.data.message);
          setOtpSent(false);
          setFormData({
            name: "",
            fname: "",
            dob: "",
            email: "",
            number: "",
            state: "",
            district: "",
            program: "",
            alc: "",
            declaration: false,
          });
          setOtp("");

          setBankData(res.data);
          setTimeout(() => {
            document.forms["payuForm"].submit();
          }, 500);
        }
        else {
          toast.error(res.data?.message);
        }

      } catch (error) {
        toast.error(error.response?.data?.message);
      }
      finally {
        setLoading(false);
      }
    }





  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let newValue = value;
    if (name === "name" || name === "fname") {

      newValue = value.replace(/[^A-Za-z\s]/g, "");
    }
    if (name === "number") {

      newValue = value.replace(/\D/g, "");


      if (newValue.length > 10) {
        newValue = newValue.slice(0, 10);
      }
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: type === "checkbox" ? checked : newValue,
    }));


  };


  const validateForm = () => {
    let newErrors = {};

    if (!formData.firstName.trim()) newErrors.firstName = "First Name is required";
    if (!formData.lastName.trim()) newErrors.lastName = "Last Name is required";
    if (!formData.fname.trim()) newErrors.fname = "Father's Name is required";
    if (!formData.dob) newErrors.dob = "Date of Birth is required";

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
      newErrors.email = "Enter a valid email address";
    }

    if (!formData.number.trim()) {
      newErrors.number = "Phone number is required";
    } else if (!/^[6-9][0-9]{9}$/.test(formData.number)) {
      newErrors.number = "Must be 10 digits, starting with 6-9";
    }
    if (!formData.state.trim()) newErrors.state = "State is required";


    if (!formData.district.trim()) newErrors.district = "District is required";

    if (!formData.program.trim()) newErrors.program = "Program selection is required";

    if (!formData.alc.trim()) newErrors.alc = "ALC selection is required";

    if (!formData.declaration) newErrors.declaration = "You must agree to proceed";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // const isFormValid = Object.keys(errors).length === 0 && formData.declaration;

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="home-dashboard">
          <div className="ticket-tab">
            <h3 className="text-center text-uppercase text-success" style={{ fontWeight: "500" }}>
              Register<span style={{ color: "#20e61b" }}> Student</span>
            </h3>

            <hr style={{ color: "#ffc107" }} />

            <div className="row">
              <div className="col-md-6 form-group my-3">
                <label className="mb-2">First Name:<span style={{ color: "red" }}>*</span></label>
                <input
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter First Name"
                  disabled={otpSent}
                />
                {errors.firstName && <span className="text-danger">{errors.firstName}</span>}
              </div>
              <div className="col-md-6 form-group my-3">
                <label className="mb-2">Last Name:<span style={{ color: "red" }}>*</span></label>
                <input
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter Last Name"
                  disabled={otpSent}
                />
                {errors.lastName && <span className="text-danger">{errors.lastName}</span>}
              </div>




              <div className="col-md-6 form-group my-3">
                <label className="mb-2">Father’s Name:<span style={{ color: "red" }}>*</span></label>
                <input
                  name="fname"
                  value={formData.fname}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter Father's Name"
                  disabled={otpSent}
                />
                {errors.fname && <span className="text-danger">{errors.fname}</span>}
              </div>

              <div className="col-md-6 form-group my-3">
                <label className="mb-2">Date of Birth:<span style={{ color: "red" }}>*</span></label>
                <input
                  type="date"
                  name="dob"
                  value={formData.dob}
                  onChange={handleChange}
                  className="form-control"
                  disabled={otpSent}
                  onKeyDown={(e) => e.preventDefault()}
                  max={new Date(new Date().setFullYear(new Date().getFullYear() - 14))
                    .toISOString()
                    .split("T")[0]}
                />
                {errors.dob && <span className="text-danger">{errors.dob}</span>}
              </div>

              <div className="col-md-6 form-group my-3">
                <label className="mb-2">Email Address:<span style={{ color: "red" }}>*</span></label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter Email Address"
                  disabled={otpSent}
                />
                {errors.email && <span className="text-danger">{errors.email}</span>}
              </div>

              <div className="col-md-6 form-group my-3">
                <label className="mb-2">Phone Number:<span style={{ color: "red" }}>*</span></label>
                <input
                  type="tel"
                  name="number"
                  value={formData.number}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Enter Contact Number"
                  disabled={otpSent}
                />
                {errors.number && <span className="text-danger">{errors.number}</span>}
              </div>
              <div className="col-md-6 form-group my-3">
                <label className="mb-2">State:<span style={{ color: "red" }}>*</span></label>
                <select className="form-control" name="state" disabled={otpSent} value={formData.state} onChange={(e) => { handleChange(e); selectDistrict(e) }}>
                  <option value={""}>Select State...</option>
                  {state?.map((item, index) => (
                    <option key={index} value={item.code} >{item.name}</option>

                  ))}

                </select>
                {errors.state && <span className="text-danger">{errors.state}</span>}
              </div>
              <div className="col-md-6 form-group my-3">
                <label className="mb-2">District:<span style={{ color: "red" }}>*</span></label>
                <select className="form-control" name="district" value={formData.district} disabled={otpSent} onChange={(e) => { handleChange(e); selectAlc(e) }}>
                  <option value={""}>Select District...</option>
                  {district?.map((item, index) => (
                    <option key={index} value={item.code} >{item.name}</option>

                  ))}
                </select>
                {errors.district && <span className="text-danger">{errors.district}</span>}
              </div>
              <div className="col-md-6 form-group my-3">
                <label className="mb-2">Program with Selected Duration:<span style={{ color: "red" }}>*</span></label>
                <select className="form-control" name="program" value={formData.program} disabled={otpSent} onChange={handleChange}>
                  <option value={""}>Select Program...</option>
                  {program?.map((item, index) => (
                    <option key={index} value={item.code} >{item.name}</option>

                  ))}
                </select>
                {errors.program && <span className="text-danger">{errors.program}</span>}
              </div>
              <div className="col-md-6 form-group my-3">
                <label className="mb-2">Authorized Learning Centre: <span style={{ color: "red" }}>*</span></label>
                <select className="form-control" name="alc" value={formData.alc} disabled={otpSent} onChange={handleChange}>
                  <option value={""}>Select ALC...</option>
                  {alc?.map((item, index) => (
                    <option key={index} value={item.code} >{item.name}</option>

                  ))}
                </select>
                {errors.alc && <span className="text-danger">{errors.alc}</span>}
              </div>
            </div>

            <div className="mt-4" style={{ textAlign: "justify" }}>
              <div className=" d-flex align-items-start ">
                <input className="mt-1 me-2"
                  type="checkbox"
                  name="declaration"
                  checked={formData.declaration}
                  onChange={handleChange}
                  disabled={otpSent}
                />{" "}
                I declare that the information provided in this form is accurate and complete to
                the best of my knowledge. I acknowledge that the selected program and duration are final and cannot be
                changed once the registration is confirmed. I agree to pay the applicable fee for the selected program and
                understand that the fee is non-refundable under any circumstances. I give my consent to the collection and
                storage of my entered personal information in accordance with HKCL's privacy policy. Furthermore, I accept
                that HKCL reserves the right to amend program schedules or content as necessary.

              </div>
              {errors.declaration && <span className="text-danger ms-4">{errors.declaration}</span>}
            </div>

            <div className="row justify-content-center">
              {otpSent ? (
                <>
                  <div className="col-md-4 form-group my-3">
                    <label className="mb-2">OTP:</label>
                    <input
                      type="tel"
                      name="otp"
                      value={otp}
                      onChange={handleOTPChange}
                      className="form-control"
                      placeholder="Enter OTP"
                    />
                    {errors.otp && <span className="text-danger">{errors.otp}</span>}
                  </div>
                  <div className="col-md-5 form-group my-3 pt-2">
                    <div className="text-center mt-4">
                      <button
                        className="btn btn-success mx-2"
                        onClick={async (e) => {
                          e.preventDefault();
                          const success = await verifyOtp(); // call API
                          if (success && document.forms["payuForm"]) {
                            document.forms["payuForm"].submit(); // redirect to bank
                          }
                        }}
                        disabled={otp.length === 0}
                      >
                        Proceed to Pay
                      </button>
                      <button
                        className="btn btn-danger mx-2"
                        onClick={sendOtp}
                        disabled={resendTimer > 0}
                      >
                        {resendTimer > 0 ? `Resend in ${resendTimer}s` : "Resend OTP"}
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <div className="text-center mt-3">
                  <button className="btn btn-success" onClick={sendOtp}>
                    Send OTP
                  </button>
                </div>
              )}

              {bankData && (
                <form
                  name="payuForm"
                  action={bankData?.action}
                  method="post"
                  style={{ display: "none" }}
                >
                  {Object.entries(bankData).map(
                    ([key, value]) =>
                      key !== "action" && (
                        <input key={key} type="hidden" name={key} value={value} />
                      )
                  )}
                </form>
              )}
            </div>


          </div>
        </div>
      )}
    </>
  );
};

export default Images;
